import { Icon } from "./Icon.tsx";

/** "Chart" view toggle — bottom+left axes with a single trend line, distinct from ProfileIcon.tsx's own axis-less terrain line and StatisticsIcon.tsx's own scatter+dashed-trend glyph (both already tied to a different feature each). */
export function ResultsDashboardChartIcon() {
  return (
    <Icon>
      <path d="M4 4v16h16" />
      <path d="M7 15 11 10l3 3 5-6" />
    </Icon>
  );
}
